export default "/assets/images/favicon.svg?5d47542ab1589540da6f929db64ec463";